import { Component } from '@angular/core';
import { MenuStateService } from '../../services/menu-state.service';

@Component({
  selector: 'app-menu-usuario',
  standalone: false,
  templateUrl: './menu-usuario.component.html',
  styleUrl: './menu-usuario.component.css'
})
export class MenuUsuarioComponent {
  constructor(private menuStateService: MenuStateService) {
    }
  cerrarMenu(): void {
    this.menuStateService.toggleMenu(false);
  }
}
